<template>
  <div class="meter-water-manage-container">
    <el-row :gutter="20">
      <el-col :span="4" class="tree-container">
        <room-tree-div ref="roomTree" @selectRoom="handleSelectRoom" />
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('meterWater.queryConditions') }}</span>
          </div>
          <el-form :inline="true" :model="conditions" class="demo-form-inline text-left">
            <el-form-item >
              <el-select v-model="conditions.meterType" :placeholder="$t('meterWater.selectMeterType')" clearable
                style="width: 100%">
                <el-option v-for="item in meterTypes" :key="item.typeId" :label="item.typeName" :value="item.typeId" />
              </el-select>
            </el-form-item>
            <el-form-item >
              <el-input v-model="conditions.waterId" :placeholder="$t('meterWater.inputMeterId')" clearable />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleQuery">{{
                $t('common.query')
              }}</el-button>
              <el-button @click="handleReset">{{ $t('common.reset') }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="box-card margin-top">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('meterWater.meterReadingInfo') }}</span>
            <div style="float: right">
              <el-button type="primary" size="small" :loading="SMSLoading" @click="handleGetSMS">
                发送缴费通知短信
              </el-button>
              <el-button type="primary" size="small" :loading="electricLoading" @click="handleGetElectricMeterCount">
                获取电表数
              </el-button>
              <el-button type="primary" size="small" @click="handleOpenBatchMeter">
                批量抄表
              </el-button>
              <el-button v-if="conditions.objId" type="primary" size="small" @click="handleOpenAddMeter">
                {{ $t('meterWater.readMeter') }}
              </el-button>
              <el-button type="danger" size="small" :disabled="selectedRows.length === 0" @click="handleBatchDelete">
                批量删除
              </el-button>
              <el-button type="text" size="small" @click="handleOpenMeterType">
                {{ $t('meterWater.meterType') }}
              </el-button>
              <el-button v-if="conditions.objId" type="text" size="small" @click="handleOpenQrCode">
                {{ $t('meterWater.qrCodeMeter') }}
              </el-button>
              <el-button type="text" size="small" style="margin-left: 10px" @click="handleOpenImport1">
                <i class="el-icon-plus"></i>{{ $t('meterWater.import1') }}
              </el-button>
              <el-button type="text" size="small" style="margin-left: 10px" @click="handleOpenImport2">
                <i class="el-icon-plus"></i>{{ $t('meterWater.import2') }}
              </el-button>
            </div>
          </div>

          <el-table ref="meterTable" :data="meterWaters" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="waterId" :label="$t('meterWater.meterId')" align="center" />
            <el-table-column prop="meterTypeName" :label="$t('meterWater.meterType')" align="center" />
            <el-table-column prop="objName" :label="$t('meterWater.objectName')" align="center" />
            <el-table-column prop="preDegrees" :label="$t('meterWater.preDegrees')" align="center" />
            <el-table-column prop="curDegrees" :label="$t('meterWater.curDegrees')" align="center" />
            <el-table-column prop="preReadingTime" :label="$t('meterWater.preReadingTime')" align="center" />
            <el-table-column prop="curReadingTime" :label="$t('meterWater.curReadingTime')" align="center" />
            <el-table-column prop="createTime" :label="$t('meterWater.createTime')" align="center" />
            <el-table-column :label="$t('common.operation')" align="center" width="180">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleEdit(scope.row)">
                  {{ $t('common.edit') }}
                </el-button>
                <el-button type="text" size="small" @click="handleDelete(scope.row)">
                  {{ $t('common.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
            :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-card>
      </el-col>
    </el-row>

    <!-- 组件 -->
    <add-meter-water ref="addMeterWater" @success="handleSuccess" />
    <edit-meter-water ref="editMeterWater" @success="handleSuccess" />
    <delete-meter-water ref="deleteMeterWater" @success="handleSuccess" />
    <import-meter-water-fee ref="importMeterWaterFee" />
    <import-meter-water-fee2 ref="importMeterWaterFee2" />
    <room-meter-qrcode ref="roomMeterQrcode" />

    <!-- 批量抄表弹窗 -->
    <el-dialog title="批量抄表" :visible.sync="batchDialogVisible" width="500px" @close="handleBatchDialogClose">
      <el-form ref="batchForm" :model="batchForm" :rules="batchRules" label-width="100px" label-position="right">
        <el-form-item label="费用类型" prop="feeTypeCd">
          <el-select v-model="batchForm.feeTypeCd" placeholder="请选择费用类型" style="width: 100%"
            @change="handleBatchFeeTypeChange">
            <el-option v-for="item in batchFeeTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="收费项目" prop="configId">
          <el-select v-model="batchForm.configId" placeholder="请选择收费项目" style="width: 100%">
            <el-option v-for="item in batchFeeConfigs" :key="item.configId" :label="item.feeName" :value="item.configId" />
          </el-select>
        </el-form-item>
        <el-form-item label="表类型" prop="meterType">
          <el-select v-model="batchForm.meterType" placeholder="请选择表类型" style="width: 100%">
            <el-option v-for="item in meterTypes" :key="item.typeId" :label="item.typeName" :value="item.typeId" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="batchForm.startTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择开始时间"
            style="width: 100%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="batchForm.endTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择结束时间"
            style="width: 100%" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="batchLoading" @click="handleBatchSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量抄表结果弹窗 -->
    <el-dialog title="批量抄表结果" :visible.sync="batchResultVisible" width="500px">
      <div style="white-space: pre-wrap; word-break: break-all;">{{ batchResultContent }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchResultVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listMeterWaters,
  listMeterTypes,
  listFeeConfigs,
  getElectricMeterCount,
  getBatchSendElectricFeeSms,
  batchMeterReading,
  deleteMeterWater
} from '@/api/fee/meterWaterManageApi'
import { getCommunityId } from '@/api/community/communityApi'
import RoomTreeDiv from '@/components/room/roomTreeDiv'
import AddMeterWater from '@/components/fee/addMeterWater'
import EditMeterWater from '@/components/fee/editMeterWater'
import DeleteMeterWater from '@/components/fee/deleteMeterWater'
import ImportMeterWaterFee from '@/components/fee/importMeterWaterFee'
import ImportMeterWaterFee2 from '@/components/fee/importMeterWaterFee2'
import RoomMeterQrcode from '@/components/fee/roomMeterQrcode'

export default {
  name: 'MeterWaterManageList',
  components: {
    RoomTreeDiv,
    AddMeterWater,
    EditMeterWater,
    DeleteMeterWater,
    ImportMeterWaterFee,
    ImportMeterWaterFee2,
    RoomMeterQrcode
  },
  data() {
    return {
      conditions: {
        waterId: '',
        meterType: '',
        roomNum: '',
        objId: '',
        page: 1,
        row: 10,
        communityId: ''
      },
      meterWaters: [],
      meterTypes: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      roomName: '',
      selectedRows: [],
      electricLoading: false,
      SMSLoading: false,
      syncLoading: false,
      // 批量抄表
      batchDialogVisible: false,
      batchLoading: false,
      batchFeeTypeOptions: [
        { value: '888800010015', label: '水费' },
        { value: '888800010016', label: '电费' },
        { value: '888800010009', label: '煤气费' }
      ],
      batchFeeConfigs: [],
      batchForm: {
        feeTypeCd: '',
        configId: '',
        meterType: '',
        startTime: '',
        endTime: ''
      },
      batchRules: {
        feeTypeCd: [{ required: true, message: '请选择费用类型', trigger: 'change' }],
        configId: [{ required: true, message: '请选择收费项目', trigger: 'change' }],
        meterType: [{ required: true, message: '请选择表类型', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }]
      },
      batchResultVisible: false,
      batchResultContent: ''
    }
  },
  created() {
    this.conditions.communityId = getCommunityId()
    this.loadData()
    this.loadMeterTypes()
  },
  methods: {
    async loadData() {
      try {
        const { data, total } = await listMeterWaters(this.conditions)
        this.meterWaters = data
        this.pagination.total = total
      } catch (error) {
        console.error('Failed to load meter waters:', error)
      }
    },
    async loadMeterTypes() {
      try {
        const { data } = await listMeterTypes({
          communityId: this.conditions.communityId,
          page: 1,
          row: 100
        })
        this.meterTypes = data
      } catch (error) {
        console.error('Failed to load meter types:', error)
      }
    },
    handleQuery() {
      this.conditions.page = 1
      this.loadData()
    },
    handleReset() {
      this.conditions.waterId = ''
      this.conditions.meterType = ''
      this.conditions.roomNum = ''
      this.loadData()
    },
    handleSizeChange(val) {
      this.conditions.row = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.conditions.page = val
      this.loadData()
    },
    handleSelectRoom({ roomId, roomName }) {
      this.conditions.objId = roomId || ''
      this.roomName = roomName || ''
      this.loadData()
    },
    // 表格多选变化
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    // 批量删除
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      this.$confirm(`确认删除选中的 ${this.selectedRows.length} 条数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.executeBatchDelete()
      }).catch(() => {})
    },
    // 执行批量删除
    async executeBatchDelete() {
      const loading = this.$loading({
        lock: true,
        text: '正在删除中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      let successCount = 0
      let failCount = 0
      const failMessages = []
      
      for (const row of this.selectedRows) {
        try {
          await deleteMeterWater({
            waterId: row.waterId,
            communityId: this.conditions.communityId
          })
          successCount++
        } catch (error) {
          failCount++
          failMessages.push(`${row.waterId}: ${error.message || '删除失败'}`)
        }
      }
      
      loading.close()
      
      // 清空选中项
      this.selectedRows = []
      this.$refs.meterTable && this.$refs.meterTable.clearSelection()
      
      // 显示结果
      if (failCount === 0) {
        this.$message.success(`成功删除 ${successCount} 条数据`)
      } else if (successCount === 0) {
        this.$message.error(`删除失败，共 ${failCount} 条`)
      } else {
        this.$message.warning(`成功删除 ${successCount} 条，失败 ${failCount} 条`)
        if (failMessages.length > 0) {
          console.error('删除失败的记录:', failMessages)
        }
      }
      
      // 刷新列表
      this.loadData()
    },
    handleOpenAddMeter() {
      this.$refs.addMeterWater.open({
        roomId: this.conditions.objId,
        roomName: this.roomName
      })
    },
    handleEdit(row) {
      this.$refs.editMeterWater.open(row)
    },
    handleDelete(row) {
      this.$refs.deleteMeterWater.open(row)
    },
    handleOpenImport1() {
      this.$refs.importMeterWaterFee.open()
    },
    handleOpenImport2() {
      this.$refs.importMeterWaterFee2.open()
    },
    handleOpenQrCode() {
      this.$refs.roomMeterQrcode.open({
        roomId: this.conditions.objId,
        roomName: this.roomName
      })
    },
    handleOpenMeterType() {
      this.$router.push('/views/fee/meterTypeManage')
    },
    handleSuccess() {
      this.loadData()
    },
    // 获取电表数
    async handleGetElectricMeterCount() {
      this.electricLoading = true
      try {
        const res = await getElectricMeterCount({
          communityId: this.conditions.communityId,
          objId: this.conditions.objId
        })
        if (res.code === 0) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error('请求失败：' + (error.message || '未知错误'))
      } finally {
        this.electricLoading = false
      }
    },
    // 发送缴费通知短信
    async handleGetSMS() {
      // 加确认弹窗，点击确定后再发送，两段文字要换行
      this.$confirm('请确认所有电表数据已同步且上传完成，确定要发送缴费通知短信吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.SMSLoading = true
        try {
          const res = await getBatchSendElectricFeeSms({
            communityId: this.conditions.communityId,
            objId: this.conditions.objId
          })
          if (res.code === 0) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        } catch (error) {
          this.$message.error('请求失败：' + (error.message || '未知错误'))
        } finally {
          this.SMSLoading = false
        }
      })
    },
    // 批量抄表 - 打开弹窗
    handleOpenBatchMeter() {
      this.resetBatchForm()
      this.batchDialogVisible = true
    },
    // 批量抄表 - 重置表单
    resetBatchForm() {
      // 上月第一天
      const now = new Date()
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 2)
      const startTime = lastMonth.toISOString().slice(0, 10)
      // 本月第一天
      const thisMonth = new Date(now.getFullYear(), now.getMonth(), 2)
      const endTime = thisMonth.toISOString().slice(0, 10)

      console.log('StartTime:', startTime, ' EndTime:', endTime)
      this.batchForm = {
        feeTypeCd: '',
        configId: '',
        meterType: '',
        startTime: startTime,
        endTime: endTime
      }
      this.batchFeeConfigs = []
      if (this.$refs.batchForm) {
        this.$refs.batchForm.clearValidate()
      }
    },
    // 批量抄表 - 弹窗关闭
    handleBatchDialogClose() {
      this.resetBatchForm()
    },
    // 批量抄表 - 费用类型变更，加载收费项目
    async handleBatchFeeTypeChange() {
      this.batchForm.configId = ''
      this.batchFeeConfigs = []
      if (!this.batchForm.feeTypeCd) return
      try {
        const { data } = await listFeeConfigs({
          communityId: this.conditions.communityId,
          feeTypeCd: this.batchForm.feeTypeCd,
          isDefault: 'F',
          page: 1,
          row: 100
        })
        this.batchFeeConfigs = data
      } catch (error) {
        console.error('Failed to load fee configs:', error)
      }
    },
    // 批量抄表 - 提交
    handleBatchSubmit() {
      this.$refs.batchForm.validate(async valid => {
        if (!valid) return
        this.batchLoading = true
        try {
          const res = await batchMeterReading({
            communityId: this.conditions.communityId,
            objId: this.conditions.objId,
            feeTypeCd: this.batchForm.feeTypeCd,
            configId: this.batchForm.configId,
            meterType: this.batchForm.meterType,
            startDate: this.batchForm.startTime,
            endDate: this.batchForm.endTime
          })
          this.batchDialogVisible = false
          this.batchResultContent = JSON.stringify(res, null, 2)
          this.batchResultVisible = true
        } catch (error) {
          this.batchDialogVisible = false
          this.batchResultContent = '请求失败：' + (error.message || JSON.stringify(error))
          this.batchResultVisible = true
        } finally {
          this.batchLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.meter-water-manage-container {
  padding: 20px;

  .tree-container {
    min-height: 450px;
    overflow-y: auto;
    background: #fff;
    padding: 10px;
    border-radius: 4px;
  }

  .margin-top {
    margin-top: 20px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }
}
</style>